import {TimelineMax} from "gsap";

export class HomeAnimations {
    /*in($newContainer, passedOptions) {
        let defaultOptions = {paused: true};
        let options        = $.extend(defaultOptions, passedOptions);
        let tl             = new TimelineMax(options);
        tl
            .fromTo($newContainer.find('.gs-title'), .5, {autoAlpha: 0, y: '-=20'}, {autoAlpha: 1, y: 0})
            .fromTo($newContainer.find('.gs-subtitle-1'), .3, {autoAlpha: 0, y: '-=10'}, {autoAlpha: 1, y: 0}, .8)
            .fromTo($newContainer.find('.btn--white'), .3, {autoAlpha: 0, y: '-=10'}, {autoAlpha: 1, y: 0})
            .fromTo($newContainer.find('.gs-content-top'), .3, {autoAlpha: 0}, {autoAlpha: 1})
        ;

        tl.add(() => {
            let scrollDist = $(window).scrollTop(),
                scrollTarget = $(window).innerHeight() / 3;
            if (scrollDist < scrollTarget) {
                $('html,body').animate({
                    scrollTop: scrollTarget
                }, 1000);
            }
        });

        return tl;
    }*/

    out($oldContainer) {
        let tl = new TimelineMax({paused: true});

        tl.add(() => {
            $('html,body').animate({
                scrollTop: 0
            }, 500);
        });

        if (window.innerWidth > 767) {

            tl
                .to($oldContainer.find('.home-video-wrapper'), .6, {yPercent: '-100%', xPercent: '-100%'}, '-=.3')
                .to($oldContainer.find('.services'), .3, {xPercent: '100%'}, '-=.8')
                .to($oldContainer.find('.contact'), .3, {yPercent: '100%'}, '-=.95')
                .to($oldContainer.find('.videos-slider'), .3, {yPercent: '100%'}, '-=.85')
            ;

        }

        return tl;
    }
}
